"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_H1
 * @param {object} fields
 * @returns
 */
const titleNormalizer = (data) => {
    try {
        let res = null;
        const { fields } = data;
        if (fields) {
            if (fields === null || fields === void 0 ? void 0 : fields.title) {
                res = { "Text-2": Object.assign(Object.assign({}, mocks_json_1.default["Text-2"]), { text: fields.title }) };
            }
            else {
                res = { "Text-1": Object.assign(Object.assign({}, mocks_json_1.default["Text"]), { text: fields.titleH1 }) };
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.default = titleNormalizer;
//# sourceMappingURL=index.js.map